<template>
   <div class="breadcrumbs" ref="el">
      <nav>
         <ol>
            <li
               v-for="(breadcrumb, index) in breadcrumbItems"
               :key="breadcrumb.name"
            >
               <component
                  :is="breadcrumb?.disabled ? 'span' : NuxtLink"
                  :href="{
                     name: breadcrumb.name,
                     params: breadcrumb.params,
                     query: breadcrumb.query,
                  }"
                  :key="breadcrumb.name"
                  class="breadcrumb-name"
                  >{{ breadcrumb.text }}</component
               >
               <span
                  v-if="index < breadcrumbItems.length - 1"
                  class="breadcrumb-delimeter"
               >
                  <IconArrow />
               </span>
            </li>
         </ol>
      </nav>
      <div class="actions">
         <slot name="actions"></slot>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconArrow from "~/assets/images/icons/arrow.svg?component";
const hook = useNuxtApp().hook;
// const route = useRoute();
const NuxtLink = resolveComponent("NuxtLink");
const { addDynamicEl } = useDynamicHeight();
const { breadcrumbItems, pageTitle, updateBreadcrumbs } = useBreadcrumbs();
const el = ref(null);
const hideBreadcrumbs = ref(false);
hook("page:loading:start", async (id) => {
   hideBreadcrumbs.value = true;
});
hook("page:loading:end", async (id) => {
   hideBreadcrumbs.value = false;
});
// >> LIFE CYCLES ------------------------------------------------------
onMounted(() => {
   addDynamicEl("breadcrumb-height", el.value);
});
watchPostEffect(() => {
   // Depend on pageTitle so that updateBreadcrumbs runs when it changes
   pageTitle.value;
   updateBreadcrumbs();
});
</script>

<style lang="scss" scoped>
@import url("~/assets/scss/breadcrumbs.scss");
</style>
